<template>
  <div class="dali-index" :style="{backgroundImage: 'url(' + imgBg+ ')'}">
    <div class="dali-title">
      <div class="details-intro">
          <div class="title">
            <!-- <div class="text">大理智慧管理平台</div> -->
            <img style="margin-bottom: 30px" :src="topBg" alt="">
          </div>
      </div>
    </div>
    <div class="controller">
      <div class="center">
      <div class="left">
        <div class="row" v-for="(item, i) in datas" :key="i">
          <div v-for="(citem, ci) in item" :class="citem.dataType" :key="ci" @click="go(citem)" :style="{backgroundColor: citem.bgColor}">
            <div v-if="citem.dataType == 'long-img'" >
              <img class="bg-long-img" :src="citem.imgUrl" alt="">
            </div>
            <div v-if="citem.dataType == 'bg-img'">
              <img :src="citem.imgUrl" alt="">
            </div>
            <div v-if="citem.dataType == 'bg-icon'" >
              <img :src="citem.imgUrl" alt="">
              <div class="icon-text">{{citem.text}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="right" @click="go" :style="{backgroundImage: 'url(' + rightImg+ ')'}">
        <div class="content">
          <img :src="rightIcon" alt="">
          <div class="icon-text">智慧环卫</div>
        </div>
        <div class="dali-date">
          <div style="font-size: 18px">{{times}}</div>
          <div style="font-size: 12px">{{week+ ' ' +dates}}</div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
import imgBg from "@/assets/images/dali/img_bg.png";
import topBg from "@/assets/images/dali/tit.png";

export default {
  computed: {
    week() {
      return "星期" + "日一二三四五六".charAt(new Date().getDay());
    },
    dates() {
      let times = new Date().toLocaleDateString().split('/')
      return times[0] + '年' + times[1] + '月' +times[2]+ '日'
    },
  },
  mounted() {
    let nowTime = new Date()
    let h = nowTime.getHours()
    let m = nowTime.getMinutes()
    this.times = h + ':' + (m < 10 ? '0'+m : m)
    setInterval(() => {
      nowTime = new Date()
      h = nowTime.getHours()
      m = nowTime.getMinutes()
      this.times = h + ':' + (m < 10 ? '0'+m : m)
    }, 10000);
  },
  data() {
    return {
      topBg,
      imgBg,
      rightImg: require('../assets/images/dali/img_map_06.png'),
      rightIcon: require('../assets/images/dali/icon_11.png'),
      times: '',
      // dataType: bg-img 背景图片 bg-icon: icon+文字， long-img: 长途
      datas: [
        [
          {
            dataType: 'bg-icon',
            imgUrl: require('../assets/images/dali/icon_01.png'),
            bgColor: '#10AEFF',
            text: '集团管控',
            next: 'http://www.eiiplat.com/',
          },
           {
            dataType: 'long-img',
            imgUrl: require('../assets/images/dali/img_map_01.png'),
            bgColor: '',
            text: '',
            next: '',
          },
          {
            dataType: 'bg-icon',
            imgUrl: require('../assets/images/dali/icon_02.png'),
            bgColor: '#34C759',
            text: '智慧园区',
            next: 'http://www.eiiplat.com/',
          },
          {
            dataType: 'bg-icon',
            imgUrl: require('../assets/images/dali/icon_03.png'),
            bgColor: '#5AC8FA',
            text: '双碳数据平台',
            next: 'http://www.eiiplat.com/',
          },
          {
            dataType: 'bg-icon',
            imgUrl: require('../assets/images/dali/icon_04.png'),
            bgColor: '#00BFD0',
            text: '运维平台',
            next: 'http://www.eiiplat.com/',
          },
        ],
        [
          {
            dataType: 'bg-icon',
            imgUrl: require('../assets/images/dali/icon_05.png'),
            bgColor: '#007AFF',
            text: '设计平台',
            next: 'http://www.eiiplat.com/',
          },
          {
            dataType: 'bg-img',
            imgUrl: require('../assets/images/dali/img_map_02.png'),
            bgColor: '',
            text: '',
            next: 'http://www.eiiplat.com/',
          },
          {
            dataType: 'bg-icon',
            imgUrl: require('../assets/images/dali/icon_06.png'),
            bgColor: '#AF52DE',
            text: '标识解析',
            next: 'http://www.eiiplat.com/',
          },
          {
            dataType: 'bg-icon',
            imgUrl: require('../assets/images/dali/icon_07.png'),
            bgColor: '#00BFD0',
            text: '供应平台',
            next: 'http://www.eiiplat.com/',
          },
          {
            dataType: 'bg-img',
            imgUrl: require('../assets/images/dali/img_map_03.png'),
            bgColor: '',
            text: '',
            next: 'http://www.eiiplat.com/',
          },
          {
            dataType: 'bg-icon',
            imgUrl: require('../assets/images/dali/icon_08.png'),
            bgColor: '#007AFF',
            text: '财务咨询系统',
            next: 'http://www.eiiplat.com/',
          },
        ],
        [
          {
            dataType: 'long-img',
            imgUrl: require('../assets/images/dali/img_map_04.png'),
            bgColor: '',
            text: '',
            next: 'http://www.eiiplat.com/',
          },
           {
            dataType: 'bg-icon',
            imgUrl: require('../assets/images/dali/icon_09.png'),
            bgColor: '#5260FF',
            text: '智能设备',
            next: 'http://www.eiiplat.com/',
          },
           {
            dataType: 'long-img',
            imgUrl: require('../assets/images/dali/img_map_05.png'),
            bgColor: '',
            text: '',
            next: 'http://www.eiiplat.com/',
          },
          {
            dataType: 'bg-icon',
            imgUrl: require('../assets/images/dali/icon_10.png'),
            bgColor: '#FF770F',
            text: '测试床',
            next: 'http://www.eiiplat.com/',
          },
        ],
      ]
    }
  },
  methods: {
    go(val) {
      window.open('http://www.eiiplat.com')
      if (val.next) {
        // this.$router.push(val.next)
      }
    }
  },
}
</script>

<style lang="scss" scoped>

.dali-index {
  padding: 120px 12%;
  color: #fff;
  height: 100%;
  min-width: 1200px;
  background-size: 100% 100%;
  background-repeat: no-repeat;

}
  .dali-title {
    margin-top: 15px;
    text-align: center;
    margin-bottom: 45px;

  .title {
    width: 100%;
    align-items: center;
    padding: 0 30px;
    margin-top: 60px;
  }
  .text {
    font-weight: 400;
    font-style: normal;
    font-size: 36px;
    font-family: 'STKaitiSC-Regular', 'Kaiti SC', sans-serif;
  }
}
.controller {
  display: flex;
  // width: 1150px;
  height: 520px;
}
.left{
  margin-right: 10px;
  width: 985px;
}
.right {
  // opacity: .8;
    width: 160px;
    height: 520px;
    background-size: 160px 520px;
    position: relative;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: 20px;
    background-repeat: no-repeat;
    justify-content: center;
    text-align: center;
  .content {
    opacity: 1;
    img {
      width: 48px;
      height: 50px;
    }
    .icon-text {
      font-weight: 400;
      font-style: normal;
      font-size: 22px;
      margin-top: 10px;
      color: #FFFFFF;
    }
  }
}
.dali-date {
  position: absolute;
  height: 60px;
  text-align: center;
  width: 160px;
  bottom: 0;
  left: 0;
  font-weight: 400;
}
.center {
  display: flex;
  justify-content: center;
  width: 100%;
}

.row {
  height: 170px;
  margin-bottom: 5px;
  &:last-child {margin-bottom: 0;}
  display: flex;
  div:last-child{
    margin-right: 0;
  }
}
.row-item, .bg-icon, .bg-img {
  width: 160px;
  height: 170px;
  margin-right: 5px;
}
.bg-img img {
  width: 160px;
  height: 170px;
}
.bg-icon{
  text-align: center;
  img {
    width: 48px;
    height: 50px;
    margin: 40px 0 20px;
  }
  .icon-text {
    font-weight: 400;
    font-style: normal;
    font-size: 22px;
    color: #FFFFFF;
  }
}

.row-item-long, .long-img {
  width: 325px;
  height: 170px;
  margin-right: 5px;
}
.bg-long-img{
  width: 325px;
  height: 170px;
}
</style>


// WEBPACK FOOTER //
// src/components/DaliComprehensive.vue